// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__NFgGx","head":"Table_head__3Tgoy","col":"Table_col__1Osu2"};